import React from 'react'
import { menuItemParams } from '../../../../types'
import style from './style.module.scss'

type childSubMenuParams = {
    item: menuItemParams
}

const ChildSubMenu: React.FC<childSubMenuParams> = ({ item }) => {
    const { children } = item

    return children.length > 0 ? (
        <ul className={style.sub}>
            {children.map((child) => (
                <li key={child.ID}>
                    <a
                        href={child.url}
                        target={child.target}
                        dangerouslySetInnerHTML={{ __html: child.title }}
                    />
                </li>
            ))}
        </ul>
    ) : null
}

export default ChildSubMenu
